export class routetypesdto {
    routetypesid: string | undefined;
    usercreated: string | undefined;
    datecreated: string | undefined;
    userupdated: string | undefined;
    dateupdated: string | undefined;
    deletedyn: boolean | false;
    code: string | undefined;
    name: string | undefined;
}